export default __webpack_public_path__ + "static/uppy-bg-base-8e89c95bff83cd45604c997fe075d27c.jpg";